import { Component, Input } from '@angular/core';
import { InventoryActionFormComponent } from '../inventory-action-form.component';
import moment from 'moment';

@Component({
    selector: 'app-inventory-action-for-buy-order-form',
    templateUrl: './inventory-action-for-buy-order-form.component.html',
    styleUrls: [
        './inventory-action-for-buy-order-form.component.scss',
        '../inventory-action-for-pricing-form/inventory-action-for-pricing-form.component.scss',
    ],
    standalone: false
})
export class InventoryActionForBuyOrderFormComponent extends InventoryActionFormComponent{

  displayedColumns = {
    alternative: 'Alternativo',
    name: 'Producto',
    quantity: 'Cantidad',
    amount: 'Precio unitario',
    total: 'Total',
   
  };

  country = this.adminService.local$.getValue().country;

  get humanColumnsNames() {
    return Object.values(this.displayedColumns);
  }

  get columnsNames() {
    return Object.keys(this.displayedColumns);
  }

  get requiredDeliveryDate() {
    return this.parentFormGroup.getRawValue()?.extra_params?.required_delivery_date
  }

  get showDatesWarning() {
    return moment(this.estimatedCompletionDateControl.value).isAfter(this.requiredDeliveryDate);
  }

  get Total(): number {
    let total = 0;
  
    this.categories.forEach(category => {
      const formArray = this.getCategoryFormArray(category.id);
      if (formArray) {
        formArray.controls.forEach(control => {
          const quantity = control.get('quantity')?.value || 0;
          const amount = control.get('amount')?.value || 0;
          total += quantity * amount;
        });
      }
    });
  
    return total;
  }
}
